import { IUserV1 } from '../tools/api.service';
import { Injectable } from "@angular/core";

@Injectable()
export class User {
    gender: string;
    name:string;
    firstname:string;
    mail:string;
    phone:string;
    mobile:string;
    language:string;

    public static parseToUser(item: User): IUserV1 {
        let result = new IUserV1();
        result.gender = item.gender;
        result.name = item.name;
        result.firstname = item.firstname;
        result.mail = item.mail;
        result.phone = item.phone;
        result.mobile = item.mobile;
        result.language = item.language;
        
        return result;
    }
}